import {
    LobbyAllGames,
    LobbyTopGames,
    LobbyCasino,
    LobbySlots,
    LobbyGameShows,
    LobbyInstants,
} from '@bg-components/Icon';
import { LobbyCategories } from './enums';

export const DEFAULT_PRESET_LOBBY_TABS_ICONS: Partial<Record<LobbyCategories, IIconComponent>> = {
    [LobbyCategories.ALL_CATEGORIES]: LobbyAllGames,
    [LobbyCategories.TOP_GAMES]: LobbyTopGames,
    [LobbyCategories.LIVE_CASINO]: LobbyCasino,
    [LobbyCategories.SLOTS]: LobbySlots,
    [LobbyCategories.GAME_SHOWS]: LobbyGameShows,
    [LobbyCategories.INSTANTS]: LobbyInstants,
};
